import React, { useEffect, useRef, useState } from "react";
import { ahWiseTHead } from "../../AssetFailuer/AssetComp/AFHelper";
import DynamicTable from "../../../Extra/DynamicTable";
import { getDaysInFYMonths, months, secondsToHHMM } from "../../../Utilitie";
import { RiResetLeftFill } from "react-icons/ri";
import { PiGreaterThan } from "react-icons/pi";
import DownloadExcel from "../../../Extra/DownloadExcel";

const LTCategoryWiseSummary = ({ data, more }) => {
  const remarkTableHeader = {
    detention_grp: "Detention Group",
    group_code: "Group Code",
    sub_group_code: "Sub Group Code",
    trainNo: "Train No",
    detTime: "Det Time",
    section: "Section",
    remark: "Remark",
  };
  const yearTR1 = useRef();
  const yearTR2 = useRef();
  const tableRef = [yearTR1, yearTR2];
  const tableAG = useRef();
  const tableSC = useRef();
  const [nearYear, setNearYear] = useState(more.years[0]);

  const yearsData = data && data.filter((a) => a.F_YEAR === nearYear);
  const [subCause, setSubCause] = useState([
    ...new Set(yearsData && yearsData.map((o) => o.group_code)),
  ]);
  let LTHead = [...new Set(yearsData && yearsData.map((o) => o.detention_grp))];
  // let subCode = ;
  const refMonths = months;

  const [filters, setFilters] = useState({
    F_YEAR: nearYear,
    A_MONTH: null,
    detention_grp: null,
    sub_group_code: null,
  });
  const tableData = Array.isArray(data)
    ? data.filter(
        (o) =>
          o.detention_grp === filters.detention_grp &&
          o.sub_group_code === filters.sub_group_code,
      )
    : [];
  const [filteredData, setFilteredData] = useState([]);
  function filterData() {
    return data?.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        if (value) {
          return item[key] === value;
        } else {
          return true;
        }
      });
    });
  }
  useEffect(() => {
    // if (Object.keys(filters).length > 0) {
    setFilteredData(filterData((data, filters)));
    // } else {
    //   setFilteredData(data);
    // }
  }, [filters, data]);
  useEffect(() => {
    if (filters.F_YEAR) {
      setNearYear(filters.F_YEAR);
    }
    if (filters.detention_grp) {
      setSubCause([
        ...new Set(
          yearsData
            .filter((o) => o.detention_grp === filters.detention_grp)
            .map((o) => o.sub_group_code),
        ),
      ]);
    } else {
      setSubCause([
        ...new Set(yearsData && yearsData.map((o) => o.sub_group_code)),
      ]);
    }
  }, [filters]);

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <h4 className="bg-dark text-white p-1 ">Month Wise Lost Train</h4>
        </div>
        <div className="row">
          {more &&
            more?.years?.map((year, j) => {
              let temp = data.filter((a) => a.F_YEAR === year);
              let tempMonths = [...new Set(temp.map((t) => t["A_MONTH"]))];
              let months = tempMonths.sort(
                (a, b) =>
                  refMonths.indexOf(a?.toUpperCase()) -
                  refMonths.indexOf(b?.toUpperCase()),
              );
              let days = temp ? getDaysInFYMonths(year, months) : 1;
              let LTHead = [...new Set(temp.map((o) => o.detention_grp))];
              let subCodes = [...new Set(temp.map((o) => o.sub_group_code))];

              return (
                <div key={j} className="col-md-6">
                  <div className=" ">
                    <div className=" ">
                      <h4 className="text-white bg-dark"> {year}</h4>
                    </div>
                    <div className="table-responsive newUiBody">
                      <table
                        className="table newUiTable table-striped table-hover"
                        ref={tableRef[j]}
                      >
                        <thead className="table-dark">
                          <tr>
                            <th>Sr.</th>
                            <th>Month</th>
                            <th>Count</th>
                          </tr>
                        </thead>
                        <tbody>
                          {months.map((m, q) => {
                            let fData = temp.filter((t) => t.A_MONTH === m);
                            return (
                              <tr
                                className={
                                  m === filters.A_MONTH &&
                                  year === filters.F_YEAR &&
                                  `border border-primary table-primary`
                                }
                                key={10 * q}
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    F_YEAR: year,
                                    A_MONTH: m,
                                  })
                                }
                              >
                                {" "}
                                <td>{q + 1}</td>
                                <td>{m}</td>
                                <td>{fData.length}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>

                      <DownloadExcel
                        tableRef={tableRef[j]}
                        fileName={`AF month Wise -${year}`}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {/* ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
        <div className="row">
          <div className="  bg-dark text-white  me-2 ms-2">
            <h4>Code wise</h4>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="  bg-dark text-white mt-1  pe-2 ps-2">
                {" "}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center ">
                    <h4>Lost Train Detention Code - </h4>
                    <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                      {Object.entries(filters).map(([key, value], i) => {
                        return i === 0 ? (
                          <h6 key={i}>{value}</h6>
                        ) : (
                          key === "detention_grp" ||
                            key === "sub_group_code" ||
                            !value || (
                              <h6 key={i}>
                                <PiGreaterThan />
                                {value}
                              </h6>
                            )
                        );
                      })}
                    </div>
                  </div>
                  <div>
                    {" "}
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        setFilters({
                          F_YEAR: nearYear,
                          A_MONTH: null,
                          detention_grp: null,
                          sub_group_code: null,
                        })
                      }
                    >
                      <RiResetLeftFill />
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive newUiBody">
                <table
                  className="table newUiTable table-striped table-hover"
                  ref={tableAG}
                >
                  <thead className="table-dark">
                    <tr>
                      <th>Sr.</th>
                      <th>Detention Code</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {LTHead.map((ah, q) => {
                      let fData = yearsData.filter((t) =>
                        filters?.A_MONTH
                          ? t.detention_grp === ah &&
                            t.A_MONTH === filters.A_MONTH
                          : t.detention_grp === ah,
                      );
                      let tempMonths = [
                        ...new Set(fData.map((t) => t["A_MONTH"])),
                      ];

                      let months = tempMonths.sort(
                        (a, b) =>
                          refMonths.indexOf(a?.toUpperCase()) -
                          refMonths.indexOf(b?.toUpperCase()),
                      );
                      let days = fData
                        ? getDaysInFYMonths(nearYear, months)
                        : 1;

                      return (
                        <tr
                          className={
                            ah === filters.detention_grp &&
                            `border border-primary table-primary`
                          }
                          key={10 * q}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            setFilters({
                              ...filters,
                              F_YEAR: nearYear,
                              detention_grp: ah,
                              sub_group_code: null,
                            })
                          }
                        >
                          <td>{q + 1}</td>
                          <td>{ah}</td>
                          <td>{fData.length}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <DownloadExcel
                  tableRef={tableAG}
                  fileName={`AF Asset Wise -${filters.F_YEAR} / ${
                    filters.A_MONTH ? filters.A_MONTH : "all "
                  } month 
                  }`}
                />
              </div>
            </div>
            {/* /////////////////////////
              Sub code
            // //////// */}
            <div className="col-md-6">
              <div className="  bg-dark text-white mt-1  pe-2 ps-2">
                {" "}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center ">
                    <h4>Sub code - </h4>
                    <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                      {Object.entries(filters).map(([key, value], i) => {
                        return i === 0 ? (
                          <h6 key={i}>{value}</h6>
                        ) : (
                          !value || key === "sub_group_code" || (
                            <h6 key={i}>
                              <PiGreaterThan />
                              {value}
                            </h6>
                          )
                        );
                      })}
                    </div>
                  </div>
                  <div>
                    {" "}
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() =>
                        setFilters({
                          F_YEAR: filters.F_YEAR,
                          A_MONTH: filters.A_MONTH,
                          detention_grp: null,
                          sub_group_code: null,
                        })
                      }
                    >
                      <RiResetLeftFill />
                    </button>
                  </div>
                </div>
              </div>
              <div className="table-responsive newUiBody  p-2 ">
                <div style={{ maxHeight: "350px", overflow: "auto" }}>
                  <table
                    className="table newUiTable table-striped table-hover mt-1 p-0"
                    ref={tableSC}
                  >
                    <thead className="table-dark sticky-top">
                      <tr>
                        <th>Sr</th>
                        <th>Sub Group Code </th>
                        <th>Count</th>
                      </tr>
                    </thead>
                    <tbody>
                      {subCause.map((cs, q) => {
                        const fData = yearsData.filter(
                          (t) =>
                            t.sub_group_code === cs &&
                            (!filters?.A_MONTH ||
                              t.A_MONTH === filters.A_MONTH) &&
                            (!filters?.detention_grp ||
                              t.detention_grp === filters.detention_grp),
                        );

                        const tempMonths = [
                          ...new Set(fData.map((t) => t.A_MONTH)),
                        ];

                        const days =
                          data && tempMonths.length > 1
                            ? getDaysInFYMonths(nearYear, tempMonths)
                            : 1;

                        return (
                          <tr
                            key={q}
                            className={
                              cs === filters?.sub_group_code
                                ? "border border-primary table-primary"
                                : ""
                            }
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setFilters((prev) => ({
                                ...prev,
                                F_YEAR: nearYear,
                                sub_group_code: cs,
                              }))
                            }
                          >
                            <td>{q + 1}</td>
                            <td>{cs}</td>
                            <td>{fData.length}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                <DownloadExcel
                  tableRef={tableSC}
                  fileName={`AF Sub code Wise-${filters.F_YEAR} / ${
                    filters.A_MONTH ? filters.A_MONTH : "all "
                  } month /  ${
                    filters.detention_grp ? filters.detention_grp : "all AG"
                  }`}
                />
              </div>
            </div>{" "}
          </div>
        </div>

        {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
        <div
          className="row
      "
        >
          {filteredData && (
            <div>
              <div className="  bg-dark text-white pe-2 ps-2">
                {" "}
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center ">
                    <h4>Failure Remarks for - </h4>
                    <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                      {Object.entries(filters).map(([key, value], i) => {
                        return i === 0 ? (
                          <h6 key={i}>{value}</h6>
                        ) : (
                          !value || (
                            <h6 key={i}>
                              <PiGreaterThan />
                              {value}
                            </h6>
                          )
                        );
                      })}
                    </div>
                  </div>
                  <div>
                    {" "}
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => setFilters({ F_YEAR: nearYear })}
                    >
                      <RiResetLeftFill />
                    </button>
                  </div>
                </div>
              </div>
              <DynamicTable
                data={filteredData}
                headers={remarkTableHeader}
                rowsPerPage={10}
                fontSize={"12px"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default LTCategoryWiseSummary;
